import {
  DESKTOP_BREAKPOINT,
  MOBILE_BREAKPOINT,
  TABLET_BREAKPOINT,
} from 'src/js/modules/breakpoint-editing/constants/breakpoints';

const COL_PERCENTAGE_TOKEN_PATTERN = /^((?:[\w-]+:)*)col-\[[\d.]+%\]$/;

const WIDER_BREAKPOINTS = {
  [MOBILE_BREAKPOINT]: [TABLET_BREAKPOINT, DESKTOP_BREAKPOINT],
  [TABLET_BREAKPOINT]: [DESKTOP_BREAKPOINT],
  [DESKTOP_BREAKPOINT]: [],
};

const isWiderBreakpointPrefix = (prefix, breakpoint) => {
  const widerBreakpoints = WIDER_BREAKPOINTS[breakpoint] ?? [];

  return widerBreakpoints.some((widerBreakpoint) =>
    widerBreakpoint ? prefix.startsWith(`${widerBreakpoint}:`) : prefix === DESKTOP_BREAKPOINT
  );
};

const hasWiderColPercentageClass = (classAttributeValue, breakpoint) =>
  (classAttributeValue || '')
    .split(/\s+/)
    .filter(Boolean)
    .some((token) => {
      const match = token.match(COL_PERCENTAGE_TOKEN_PATTERN);

      return Boolean(match) && isWiderBreakpointPrefix(match[1], breakpoint);
    });

export default hasWiderColPercentageClass;
